import { Box } from "@mui/material";
import { alpha, styled } from "@mui/material/styles";

import { messaging } from "JS/Helpers/UserMessaging";
import type { DisclosureStep } from "JS/React/Hooks/DisclosureSequence";

const BadgeRow = styled(Box)(({ theme }) => ({
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    marginTop: theme.spacing(0.5),
}));

// common.black is the readable foreground in both modes, white in dark
const Pill = styled("span")(({ theme }) => ({
    background: alpha(theme.palette.common.black, 0.12),
    color: theme.palette.common.black,
    borderRadius: theme.spacing(2),
    padding: theme.spacing(0.25, 1),
    fontSize: "0.7rem",
    fontWeight: "bold",
    letterSpacing: "0.04em",
    textTransform: "uppercase",
    whiteSpace: "nowrap",
}));

const Hint = styled("span")(({ theme }) => ({
    color: theme.palette.common.black,
    opacity: 0.7,
    fontSize: "0.8rem",
}));

export interface DisclosureBadgeProps {
    placement?: DisclosureStep;
    mediaNoun?: string;
}

export const DisclosureBadge = (props: DisclosureBadgeProps) => {
    const { placement, mediaNoun = "audio" } = props;

    if (placement !== "start" && placement !== "end") return null;

    return (
        <BadgeRow>
            <Pill>{messaging.disclosure.badge}</Pill>
            <Hint>
                {placement === "start"
                    ? messaging.disclosure.playsBefore(mediaNoun)
                    : messaging.disclosure.playsAfter(mediaNoun)}
            </Hint>
        </BadgeRow>
    );
};
